import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';

const ThemeContext = createContext(null);

const STORAGE_KEY = 'argus_theme';

// Lee la preferencia guardada; si no hay ninguna, respeta el modo del sistema
// operativo/navegador (prefers-color-scheme). Envuelto en try/catch porque
// localStorage puede fallar (modo privado, storage bloqueado, etc.).
const obtenerThemeInicial = () => {
    try {
        const guardado = localStorage.getItem(STORAGE_KEY);
        if (guardado === 'dark' || guardado === 'light') return guardado;
    } catch {
        // noop
    }
    if (typeof window !== 'undefined' && window.matchMedia?.('(prefers-color-scheme: dark)').matches) {
        return 'dark';
    }
    return 'light';
};

export const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState(obtenerThemeInicial);

    useEffect(() => {
        const root = document.documentElement;
        if (theme === 'dark') {
            root.classList.add('dark');
        } else {
            root.classList.remove('dark');
        }
        try {
            localStorage.setItem(STORAGE_KEY, theme);
        } catch {
            // noop: per-viewer, no es crítico si no persiste
        }
    }, [theme]);

    const toggleTheme = useCallback(() => {
        setTheme((prev) => (prev === 'dark' ? 'light' : 'dark'));
    }, []);

    const value = { theme, isDark: theme === 'dark', toggleTheme, setTheme };

    return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => {
    const ctx = useContext(ThemeContext);
    if (!ctx) throw new Error('useTheme debe usarse dentro de ThemeProvider');
    return ctx;
};
